module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-content"
  }, [_c('div', {
    staticClass: "ushk-main ushk-content-box"
  }, [_c('div', {
    staticClass: "ushk-rili"
  }, [_c('div', {
    staticClass: "ushk-rili_header"
  }, [_c('div', {
    staticClass: "ushk-rili_tab"
  }, [_c('ul', {
    staticClass: "ushk-rili_tab-list"
  }, _vm._l((_vm.tabs), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "ushk-rili_tab-item",
      class: {
        'active': item.type === _vm.active
      },
      on: {
        "click": function($event) {
          _vm.active = item.type
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.curDate) ? _c('week', {
    attrs: {
      "date": _vm.curDate
    },
    on: {
      "dateChange": _vm.onDateChange
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ushk-rili_body"
  }, [_c('list-filter', {
    on: {
      "change": _vm.filterChange
    }
  }), _vm._v(" "), _vm._l((_vm.datas), function(item, key) {
    return _c('list-group', {
      key: key,
      attrs: {
        "type": key,
        "datas": item
      }
    })
  })], 2), _vm._v(" "), _c('mobile-content', {
    attrs: {
      "economics-datas": _vm.datas.economics,
      "stock-after": _vm.datas.stockAfter,
      "stock-pre": _vm.datas.stockPre,
      "stock-hk": _vm.datas.stockHk,
      "eventsDatas": _vm.datas.events,
      "holiday-datas": _vm.datas.holiday,
      "active": _vm.active
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ushk-side"
  }, [_c('div', {
    staticClass: "ushk-side__wrap"
  }, [_c('ad', {
    attrs: {
      "paddingTop": false
    }
  }), _vm._v(" "), _c('contract'), _vm._v(" "), _c('Declatration')], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-rili_header-btn"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('i', {
    staticClass: "ushk-icon ushk-icon_calendar1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-505b5e3c","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/calendar/pages/home.vue
// module id = JDz3
// module chunks = 3